import * as React from 'react'
import { TopSearchContainer } from '../../../features/GlobalSearch/Search/TopSearchContainer'
import SearchIcon from '@mui/icons-material/Search'
import { getStyles } from './useStyles'
import Button from '@mui/material/Button'
import Popover from '@mui/material/Popover'
import { FilterDrawer } from '@user/features/GlobalSearch/FilterDrawer'
import { useTheme } from '@mui/material/styles'
import { MapViewDialog } from '@user/features/MapView/MapViewDialog/MapViewDialog'
import { useHandlers } from '../hooks/useHandler'

export const SearchButton = () => {
  const {
    anchorEl,
    mapViewParams,
    mapViewDialogOpen,
    topSearch,
    handleCloseDialogClick,
    onClose,
    onOpenFilterDrawer,
    open,
    onOpen,
    sideDrawerOpen,
    setSideDrawerClose,
    openMapViewDialog,
  } = useHandlers()

  const theme = useTheme()
  const styles = getStyles(theme)

  return (
    <>
      <Button
        color="primary"
        variant="outlined"
        onClick={onOpen}
        data-test-id="searchIconBtn"
        sx={{
          height: '47px',
          minWidth: '47px',
          padding: theme.spacing(1),
        }}
      >
        <SearchIcon sx={styles.searchIcon} data-test-id="searchIcon" />
      </Button>
      {!sideDrawerOpen && !mapViewDialogOpen && (
        <Popover
          id={'searchPopover'}
          open={open}
          onClose={onClose}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            elevation: 4,
            sx: { padding: theme.spacing(2) },
          }}
          slotProps={{
            paper: { elevation: 4, sx: { ...styles.searchContent } },
          }}
          sx={{
            ...styles.root,
          }}
        >
          <TopSearchContainer
            onClose={onClose}
            onSearchAddressClick={openMapViewDialog}
            topSearch={topSearch}
            onCustomizeDrawerOpen={onOpenFilterDrawer}
          />
        </Popover>
      )}
      <FilterDrawer onClose={setSideDrawerClose} open={sideDrawerOpen} />

      {mapViewDialogOpen && mapViewParams && mapViewParams.location && (
        <MapViewDialog
          open={mapViewDialogOpen}
          center={mapViewParams.location}
          onClose={handleCloseDialogClick}
          zoom={18}
          serviceLocationId={mapViewParams.serviceLocationId ?? 0}
          entityId={mapViewParams.entityId}
          entityType={mapViewParams.entityType}
        />
      )}
    </>
  )
}

SearchButton.displayName = 'SearchButton'
